import { __assign, __rest } from "tslib";
import React from 'react';
import VeltNotificationsPanelContentPeopleListItemWireframe from './VeltNotificationsPanelContentPeopleListItemWireframe/VeltNotificationsPanelContentPeopleListItemWireframe';
import { transformWireframeProps } from '../../../../../utils/propUtils';
var VeltNotificationsPanelContentPeopleListWireframe = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-notifications-panel-content-people-list-wireframe", __assign({}, transformedProps), children));
};
VeltNotificationsPanelContentPeopleListWireframe.Item = VeltNotificationsPanelContentPeopleListItemWireframe;
export default VeltNotificationsPanelContentPeopleListWireframe;
